<template>
  <div class="form-card__header form-card__header--toggle" @click="$emit('toggle')">
    <h6 class="form-card__title">
      <i class="bi bi-shop"></i>
      {{ isNew ? 'Nueva Sucursal' : 'Sucursal ' + branchoffice.name }}
    </h6>
    <i class="bi form-card__chevron" :class="open ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
  </div>
</template>

<script>
export default {
  props: ['branchoffice', 'new', 'open'],
  data: function () {
    return {
      newbranchoffice: null,
      isNew: false
    }
  },
  computed: {

  },
  mounted() {
    this.isNew = this.new;
    this.newbranchoffice = this.branchoffice;
  }
}
</script>